import React from "react";
import { useSelector } from 'react-redux'

const QuestionOptions = ({ actionProvider, faqData }) => {
  const language = useSelector((state) => state.language.language)
  return (
    <div>
      {faqData.map((item, index) => (
        <div
          key={index}
          style={{ margin: "5px 0", cursor: "pointer", color: "#007bff" }}
          onClick={() => actionProvider.handleShowAnswer(item.answer)}
        >
         {index + 1}. {item?.question?.[language]}
        </div>
      ))}
    </div>
  );
};

export default QuestionOptions;
